export default {
    totalAmount() {
        const eventIds = []
        let value = this.jobs.map(job => {
            if (!eventIds[job.event.id]) {
                eventIds[job.event.id] = true
                return (this.view === 'contractor' ? (job.event?.order?.amount + job.totalRefunds) : ((job.fee * job.event.totalDays) + job.refundsSubtotal))
            }
            return 0
        }).reduce((accumulator, current) => accumulator + current, 0)

        return value
    },

    events() {
        const events = []

        for (let job of this.jobs) {
            const eventExists = events.filter(event => {
                return event.event.id === job.event.id
            })

            if (!eventExists.length) {
                events.push(job)
            }
        }

        return events
    },

    user() {
        return this.$store.state.session.user
    }
}
